import colorPalette from './colorPalette'
import silverStyle from './silverStyle'

const {
  COLOR_BACKGROUND_MAP,
  COLOR_MARKER_BORDER,
  COLOR_MARKER_FILL,
  COLOR_MARKER_TEXT,
  COLOR_LINE
} = colorPalette

const COLORS = {
  BAKGROUND_MAP: COLOR_BACKGROUND_MAP,
  MARKER_BORDER: COLOR_MARKER_BORDER,
  MARKER_FILL: COLOR_MARKER_FILL,
  MARKER_TEXT: COLOR_MARKER_TEXT,
  LINE: COLOR_LINE
}

const POINT_MARKER_ICON_CONFIG = {
  path: 'M 0, 0 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0',
  strokeOpacity: 0.4,
  strokeWeight: 1,
  strokeColor: COLORS.MARKER_BORDER,
  fillColor: COLORS.MARKER_FILL,
  fillOpacity: 1,
  scale: 1.8
}

const LINE_SYMBOL_CONFIG = {
  path: 'M 0,-2 0,2',
  strokeOpacity: 1,
  strokeWeight: 1.5,
  scale: 1
}

const ARROW_SYMBOL_CONFIG = {
  path: 'M -5,0 0,5 5,0',
  strokeOpacity: 1,
  strokeWeight: 2,
  scale: 1
}

const LINE_PATH_CONFIG = {
  clickable: false,
  geodesic: true,
  strokeOpacity: 0,
  strokeColor: COLORS.LINE,
  icons: [
    {
      icon: LINE_SYMBOL_CONFIG,
      repeat: '10px'
    },
    {
      icon: ARROW_SYMBOL_CONFIG,
      offset: '18px'
    }
  ]
}

const mapSettings = {
  clickableIcons: false,
  streetViewControl: false,
  panControlOptions: false,
  gestureHandling: 'cooperative',
  backgroundColor: COLORS.BAKGROUND_MAP,
  mapTypeControl: false,
  styles: silverStyle,
  zoomControl: true,
  zoomControlOptions: { style: 'SMALL' },
  zoom: 5,
  minZoom: 1,
  maxZoom: 9
}

export { mapSettings, LINE_PATH_CONFIG, POINT_MARKER_ICON_CONFIG, COLORS }
